import { setFormAssemblyState } from 'js/utils/FormAssemblySubmit';

/**
 * Component for the Form Assembly Form block.
 */
export default class FormAssemblyForm {
  /**
   * Start the component.
   */
  constructor({ element, children, options }) {
    this.element = element;
    this.children = children;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);

    this.init();
  }

  /**
   * Initialize a FormAssemblySubmit instance with relevant options.
   */
  init() {
    this.element.addEventListener('sn.formstatechange', (event) => {
      setFormAssemblyState(this.element, event.detail);
    });
  }
}
